import { render, staticRenderFns } from "./OnboardingChooseInstallationTypeModal.vue?vue&type=template&id=11e12e72&scoped=true"
import script from "./OnboardingChooseInstallationTypeModal.vue?vue&type=script&lang=js"
export * from "./OnboardingChooseInstallationTypeModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingChooseInstallationTypeModal.vue?vue&type=style&index=0&id=11e12e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e12e72",
  null
  
)

export default component.exports